import { useCallback, useState } from "react";

import { avisarCambio } from "../api";
import { useToast, type AvisoToast } from "../ds";
import type { ResultadoEnvio } from "../tipos";

/* Corre una acción contra la API: marca cuál está en curso (para el `pending` del botón),
 * avisa el resultado con un toast y le cuenta al resto del panel que algo cambió. */
export function useAccion() {
  const { mostrar } = useToast();
  const [pendiente, setPendiente] = useState<string | null>(null);

  const ejecutar = useCallback(
    async <T,>(clave: string, f: () => Promise<T>, exito?: string | ((r: T) => string | AvisoToast)): Promise<T | undefined> => {
      setPendiente(clave);
      try {
        const r = await f();
        if (exito) {
          const aviso = typeof exito === "function" ? exito(r) : exito;
          mostrar(typeof aviso === "string" ? { title: aviso, tone: "success" } : { tone: "success", ...aviso });
        }
        avisarCambio();
        return r;
      } catch (e) {
        mostrar({ title: "No se pudo", message: e instanceof Error ? e.message : String(e), tone: "danger", duracion: 8000 });
        return undefined;
      } finally {
        setPendiente(null);
      }
    },
    [mostrar],
  );

  return { pendiente, ejecutar };
}

/* El aviso de "Enviar": el WhatsApp ya salió, pero si la conversación no quedó asignada en
 * Chatwoot se dice por qué, para que alguien la asigne a mano. */
export const avisoEnvio =
  (nombre: string) =>
  (r: ResultadoEnvio): AvisoToast =>
    r.asignada
      ? { title: `Enviado a ${nombre}`, message: `Asignado a ${r.asignada} en Chatwoot` }
      : { title: `Enviado a ${nombre}, sin asignar en Chatwoot`, message: r.problemaAsignacion ?? undefined, tone: "warning", duracion: 8000 };
